import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

const Modal = props => {
  const {
    open,
    onClose,
    width = 'w-11/12 md:max-w-2xl',
    title,
    children,
    customTitle = false
  } = props;

  useEffect(() => {
    if (!open) return undefined;

    function handleEscapeKey(event) {
      if (event.code === 'Escape') {
        onClose();
      }
    }

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', handleEscapeKey);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div className='siberat-modal'>
      <div className='siberat-modal__overlay' onClick={onClose} />
      <div
        className={`siberat-modal__panel ${width}`}
        onClick={e => e.stopPropagation()}
        role='dialog'
        aria-modal='true'>
        <div className='siberat-modal__header'>
          <div className='siberat-modal__title'>
            {customTitle ? (
              title
            ) : (
              <h2 className='siberat-modal__heading'>{title}</h2>
            )}
          </div>
          <button
            type='button'
            className='siberat-modal__close'
            onClick={onClose}
            aria-label='Tutup'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='16'
              height='16'
              viewBox='0 0 18 18'
              fill='currentColor'>
              <path d='M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z' />
            </svg>
          </button>
        </div>
        <div className='siberat-modal__body'>{children}</div>
      </div>
    </div>,
    document.body
  );
};

export default Modal;
